<div class="flex flex-col sm:grid grid-cols-12 gap-6">
  @if (showUtilityTypeInput()) {
    <ui-input-label class="col-span-12">
      <span>
        {{ 'cockpit.energyInterfaces.createDialog.utilityTypeLabel' | transloco }}
        <span class="text-error dark:text-error-darkmode">*</span>
      </span>

      <ui-radio-group [formField]="form.utilityType">
        <ui-radio value="ELECTRICITY">
          {{ 'cockpit.energyInterfaces.createDialog.electricityType' | transloco }}
        </ui-radio>
        <ui-radio value="GAS">
          {{ 'cockpit.energyInterfaces.createDialog.gasType' | transloco }}
        </ui-radio>
      </ui-radio-group>

      <app-field-errors
        slot="bottom"
        [fieldState]="form.utilityType()"
        [alwaysShowErrors]="showFormValidityErrors()"
      />
    </ui-input-label>
  }

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-location">
    <span>
      {{ 'cockpit.energyInterfaces.createDialog.locationLabel' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
    </span>

    <ui-select
      inputId="create-energy-interface-location"
      class="block w-full"
      [formField]="form.locationID"
    >
      <option value="" [selected]="model().locationID ? null : 'selected'">
        {{ 'cockpit.energyInterfaces.createDialog.locationPlaceholder' | transloco }}
      </option>
      @for (location of locationsStore.filteredLocations(); track location.id) {
        <option
          [value]="location.id"
          [selected]="model().locationID === location.id ? 'selected' : null"
        >
          {{ location.data | formatLocationName }}
        </option>
      }
    </ui-select>
    <app-field-errors
      slot="bottom"
      [fieldState]="form.locationID()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-label">
    <span>
      {{ 'cockpit.energyInterfaces.createDialog.labelLabel' | transloco }}
      <span class="text-error dark:text-error-darkmode">*</span>
    </span>

    <ui-input-simple
      type="text"
      inputId="create-energy-interface-label"
      class="block w-full"
      [placeholder]="'cockpit.energyInterfaces.createDialog.labelPlaceholder' | transloco"
      [formField]="form.label"
    />
    <app-field-errors
      slot="bottom"
      [fieldState]="form.label()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-maloID">
    <div class="flex items-center">
      <div class="flex-1 flex items-center gap-1">
        <span> {{ 'cockpit.energyInterfaces.createDialog.maloIDLabel' | transloco }} </span>

        <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
          <h3 slot="title" class="font-semibold">
            {{ 'help.maloID.title' | transloco }}
          </h3>
          <p>
            {{ 'help.maloID.description' | transloco }}
          </p>
          <a
            slot="footer"
            [href]="maloMeloMeterArticleUrl"
            target="_blank"
            [title]="'help.maloID.linkTitle' | transloco"
          >
            <ui-button slot="footer" mode="outlined" type="button" size="small">
              <ng-icon name="heroArrowTopRightOnSquare" size="20" slot="start" class="!block" />
              {{ 'help.maloID.linkText' | transloco }}
            </ui-button>
          </a>
        </ui-help-button>
      </div>
      <span
        class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
      >
        {{ 'validators.optional' | transloco }}
      </span>
    </div>

    <ui-input-simple
      type="text"
      inputId="create-energy-interface-maloID"
      class="block w-full"
      [placeholder]="'cockpit.energyInterfaces.createDialog.maloIDPlaceholder' | transloco"
      [formField]="form.maloID"
    />
    <app-field-errors
      slot="bottom"
      [fieldState]="form.maloID()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-meterID">
    <div class="flex items-center">
      <div class="flex-1 flex items-center gap-1">
        <span> {{ 'cockpit.energyInterfaces.createDialog.meterIDLabel' | transloco }} </span>
        <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
          <h3 slot="title" class="font-semibold">
            {{ 'help.meterID.title' | transloco }}
          </h3>
          <p>
            {{ 'help.meterID.description' | transloco }}
          </p>
        </ui-help-button>
      </div>

      <span
        class="text-on-surface-variant dark:text-on-surface-variant-darkmode text-sm font-normal"
      >
        {{ 'validators.optional' | transloco }}
      </span>
    </div>

    <ui-input-simple
      type="text"
      inputId="create-energy-interface-meterID"
      class="block w-full"
      [placeholder]="'cockpit.energyInterfaces.createDialog.meterIDPlaceholder' | transloco"
      [formField]="form.meterID"
    />
    <app-field-errors
      slot="bottom"
      [fieldState]="form.meterID()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-measurementType">
    <div class="flex items-center gap-1">
      <span>
        {{ 'cockpit.energyInterfaces.createDialog.measurementTypeLabel' | transloco }}
      </span>
      <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
        <h3 slot="title" class="font-semibold">
          {{ 'help.measurementType.title' | transloco }}
        </h3>
        <p>
          {{ 'help.measurementType.description' | transloco }}
        </p>
      </ui-help-button>
    </div>

    <ui-select
      inputId="create-energy-interface-measurementType"
      class="block w-full"
      [formField]="form.measurementType"
    >
      <option value="RLM" [selected]="model().measurementType === 'RLM' ? 'selected' : null">
        {{ 'cockpit.energyInterfaces.createDialog.measurementTypeRLM' | transloco }}
      </option>
      <option value="SLP" [selected]="model().measurementType === 'SLP' ? 'selected' : null">
        {{ 'cockpit.energyInterfaces.createDialog.measurementTypeSLP' | transloco }}
      </option>
    </ui-select>
    <app-field-errors
      slot="bottom"
      [fieldState]="form.measurementType()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>

  <ui-input-label class="col-span-6" labelFor="create-energy-interface-flowDirection">
    <div class="flex items-center gap-1">
      <span>
        {{ 'cockpit.energyInterfaces.createDialog.flowDirectionLabel' | transloco }}
      </span>
      <ui-help-button class="flex-none -my-[5px] font-normal text-sm">
        <h3 slot="title" class="font-semibold">
          {{ 'help.flowDirection.title' | transloco }}
        </h3>
        <p>
          {{ 'help.flowDirection.description' | transloco }}
        </p>
      </ui-help-button>
    </div>

    <ui-select
      inputId="create-energy-interface-flowDirection"
      class="block w-full"
      [formField]="form.flowDirection"
    >
      <option
        value="CONSUMPTION"
        [selected]="model().flowDirection === 'CONSUMPTION' ? 'selected' : null"
      >
        {{ 'cockpit.energyInterfaces.createDialog.flowDirectionConsumption' | transloco }}
      </option>
      <option value="FEED_IN" [selected]="model().flowDirection === 'FEED_IN' ? 'selected' : null">
        {{ 'cockpit.energyInterfaces.createDialog.flowDirectionFeedIn' | transloco }}
      </option>
    </ui-select>
    <app-field-errors
      slot="bottom"
      [fieldState]="form.flowDirection()"
      [alwaysShowErrors]="showFormValidityErrors()"
    />
  </ui-input-label>
</div>
